import React from 'react';
import ReactDOM from 'react-dom/client';
// Estilos globales: el orden importa, cada uno pisa al anterior. Tienen que
// ir antes de App para que Bootstrap no quede por encima de nuestro tema.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';
import './index.css';
import './styles/tokens.css';
import './styles/theme.css';
import './components/ui/ui.css';
import './styles/mobile.css';
import App from './App';
import { installFetchInterceptor } from './utils/fetchInterceptor';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { instalarEnAxios } from './utils/formDataJson';
import api from './api/client';
installFetchInterceptor();
// El hosting corta los POST multipart: el FormData viaja como JSON (utils/formDataJson)
instalarEnAxios(axios);
instalarEnAxios(api);

// Forzar favicon VADIEG
(()=>{
  const svgUrl = process.env.PUBLIC_URL + '/favicon.svg';
  document.querySelectorAll("link[rel*='icon']").forEach(el=>el.remove());
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = svgUrl + '?v=' + Date.now();
  document.head.appendChild(link);
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker desactivado
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}

reportWebVitals();
